import { takeLatest, select, call } from 'redux-saga/effects';
import { without } from 'ramda';
import qs from 'qs';
import { UPDATE_QUERY_STRING } from '../actions';
import { offersQuerySelector } from '../selectors';
import { ALL_COUNTRIES_AND_RESORTS } from '../constants';
import { MealPlanNames } from 'services/BackendApi';
import { selectedCompanySelector, selectedTaSelector } from '../../agents/selectors';

export function* updateQueryStringSaga() {
  // We need to sanitize the query a little
  const query = yield select(offersQuerySelector);
  const selectedCompany = yield select(selectedCompanySelector);
  const selectedTa = yield select(selectedTaSelector);

  // Get existing URL parameters to preserve company/TA UUIDs during loading
  const currentUrlParams = qs.parse(window.location.search.slice(1));

  const sanitizedQuery = yield {
    ...query,
    startDate: query.startDate.split('T')[0],
    endDate: query.endDate.split('T')[0],
    name: query.name === ALL_COUNTRIES_AND_RESORTS ? '' : query.name,
    mealPlanCategories: without([MealPlanNames.ANY], query.mealPlanCategories),
    // Preserve company and TA UUIDs - use Redux state if available, otherwise preserve from URL
    ...(selectedCompany?.uuid
      ? { companyUuid: selectedCompany.uuid }
      : currentUrlParams.companyUuid
      ? { companyUuid: currentUrlParams.companyUuid }
      : {}),
    ...(selectedTa?.uuid
      ? { tauuid: selectedTa.uuid }
      : currentUrlParams.tauuid
      ? { tauuid: currentUrlParams.tauuid }
      : {}),
  };
  const params = yield qs.stringify(sanitizedQuery);
  yield call(window.history.replaceState, {}, '', decodeURIComponent(`${location.pathname}?${params}`));
}

export function* watchUpdateQueryString() {
  yield takeLatest(UPDATE_QUERY_STRING, updateQueryStringSaga);
}
